export const ActivityStatusTypes = {
    createNew: 0,
    scheduled: 1,
    completed: 2,
    uncompleted: 3
}
